"use strict";
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(exports.DayOfWeek || (exports.DayOfWeek = {}));
var DayOfWeek = exports.DayOfWeek;

//# sourceMappingURL=DatePicker.Props.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/DatePicker/DatePicker.Props.js
 ** module id = 100
 ** module chunks = 0
 **/